import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { Location } from "@angular/common";
import { CommonService } from "projects/services/src/app/API/nsdccommonService/common.service";
@Component({
  selector: "app-pmv-languages-resoureces",
  templateUrl: "./pmv-languages-resoureces.component.html",
  styleUrls: ["./pmv-languages-resoureces.component.css"],
})
export class PmvLanguagesResourecesComponent {
  languages: any;
  dashboardCards: any;
  dataMessage: string;
  constructor(
    private router: Router,
    private commonservice: CommonService,
    public location: Location
  ) {}

  ngOnInit() {
    this.getLanguages();
  }

  getLanguages() {
    
    let langdata = JSON.parse(sessionStorage.getItem("pmvLang"));
    if (langdata) {
      this.languages = langdata;
    } else {
      this.commonservice.getLanguages().subscribe((res: any) => {
        console.log("Languages", res, res.language);
        this.languages = res.lanaguages;
        sessionStorage.setItem("pmvLang", JSON.stringify(res.lanaguages));
        console.log(this.languages);
      });
    }
  }

  redirectTrades(code) {
    console.log(code);
    this.router.navigate(["/trades"], { queryParams: { langcode: code } });
  }

  back() {
    // this.location.back();
    this.router.navigate(["/login"]);
  }
}
